import { Card, Text, Image, Button } from "@mantine/core";
import "./DemoSubCard.scss";

interface DemoSubCardProps {
  imageSrc: string;
  title: string;
  description: string;
  extraText?: string;
  buttonText: string;
  buttonHandler: () => void;
}

const DemoSubCard = ({
  imageSrc,
  title,
  description,
  extraText,
  buttonText,
  buttonHandler,
}: DemoSubCardProps) => {
  return (
    <Card shadow="sm" padding="lg" radius="md" withBorder className="demo-card">
      <Card.Section className="demo-card-img">
        <Image
          src={imageSrc}
          height={100}
          width="auto"
          fit="contain"
          alt={title}
        />
      </Card.Section>
      <div className="demo-card-content">
        <Text fw={500} mb="xs">
          {title}
        </Text>
        <Text size="sm" c="dimmed" mb="md">
          {description}
        </Text>
        {extraText && (
          <Text c="#0077cc" fw={500} mt="lg" mb="md">
            {extraText}
          </Text>
        )}
        <Button color="blue" mt="md" radius="md" onClick={buttonHandler}>
          {buttonText}
        </Button>
      </div>
    </Card>
  );
};

export default DemoSubCard;
